import React, { useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { WorkOrderWithBuilding } from '../../../types/workOrders';
import { UseWorkOrderSectionsReturn } from '../../../hooks/workOrders/useWorkOrderSections';
import {
    WorkOrderSectionsCheckboxes,
    WorkOrderSectionFlags,
    workOrderSectionFlagsFrom
} from './WorkOrderSectionsCheckboxes';

const SECTION_KEYS: (keyof WorkOrderSectionFlags)[] = [
    'notes',
    'checklists',
    'beforePictures',
    'progressPictures',
];

/**
 * Admin "Ändra sektioner" button. Opens a small modal with the section checkboxes
 * (the same ones used when creating a work order). Each toggle is applied
 * immediately via the sections hook — optimistic, no page reload, no save button.
 * The checkbox state is derived from the work order itself, so it always reflects
 * the live value.
 */
export const WorkOrderSectionsEditor: React.FC<{
    workOrder: WorkOrderWithBuilding;
    sections: UseWorkOrderSectionsReturn;
}> = ({ workOrder, sections }) => {
    const [show, setShow] = useState(false);

    const flags = workOrderSectionFlagsFrom(workOrder.enabledSections);

    const handleChange = (next: WorkOrderSectionFlags) => {
        // Exactly one checkbox changes per onChange — find it and apply immediately.
        const key = SECTION_KEYS.find((k) => next[k] !== flags[k]);
        if (key) {
            void sections.setSectionEnabled(key, next[key]);
        }
    };

    const handleOpen = () => {
        sections.clearError();
        setShow(true);
    };

    return (
        <div>
            <Button variant="outline-primary" size="sm" onClick={handleOpen}>
                Ändra dokumentation
            </Button>

            <Modal show={show} onHide={() => setShow(false)} size="sm" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Ändra dokumentation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {sections.error && (
                        <Alert variant="danger" className="py-2">
                            {sections.error}
                        </Alert>
                    )}
                    <WorkOrderSectionsCheckboxes
                        value={flags}
                        onChange={handleChange}
                        heading=""
                        idPrefix="edit-"
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShow(false)}>
                        Stäng
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
